import { ReadAloud } from '@3plearning/question-components-library';
import { Box } from '@chakra-ui/react';
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import logo from '../../assets/images/mathletics-logo.svg';
import backIcon from '../../assets/images/back-icon.svg';
import css from './header.scss';
import { BtnIcon } from '../../components/buttons';
import Profile from '../profile/profile';
import { useFinish } from '../footer-qtc/hooks/use-finish';

const Header = ({
  onLocaleChange,
  category = 'Category',
  title = 'Title'
}) => {
  const { handleFinish } = useFinish();

  return (
    <div className={css.header}>
      <div className={css.left}>
        <BtnIcon
          title={t`Back to Student Console`}
          aria-label={t`Back to Student Console`}
          icon={backIcon}
          className={css.back}
          callBack={handleFinish}
        />
        <BtnIcon
          icon={logo}
          className={css.logo}
          title={t`Mathletics Home`}
          aria-label={t`Mathletics Home`}
          callBack={handleFinish}
        />
        <div className={css.text}>
          <p>{category}</p>
          <h1 className={css.title}>{title}</h1>
        </div>
      </div>
      <div className={css.right}>
        <Box mr="15px">
          <ReadAloud
            onConfigChange={({ locale }) => onLocaleChange(locale)}
            popoverLabels={{
              readAloud: t`Read aloud`,
              transcribe: t`Transcribe`
            }}
          />
        </Box>
        <Profile />
      </div>
    </div>
  );
};

Header.propTypes = {
  onLocaleChange: PropTypes.func.isRequired,
  category: PropTypes.string,
  title: PropTypes.string
};

export default Header;
